import { StyledSpan } from './IconWrapper.styles';
import React from 'react';

export interface IconProps {
  children: React.ReactNode;
  className?: string;
}

export const IconWrapper: React.FC<IconProps> = ({ children, className }) => {
  return <StyledSpan className={className}>{children}</StyledSpan>;
};
